module.exports = __webpack_public_path__ + "img/2020_11_12_creepy_cat.9dbf8b05.jpg";